import React from "react";
// import "./UserProfilePopUp.css";
import closeCoss from "../../assets/images/CloseCrossSmall.png";
import { PERSONALHUB_PAGE } from "../../helpers/constants/Constants";
import { useDispatch, useSelector } from "react-redux";
import {
  SELECTED_ICON,
  updateNavigationState,
} from "../../helpers/reducers/NavigationReducer";

function UserProfilePopUp(props) {
  const { selectedProject } = useSelector((state) => state.globalReducer);
  const dispatch = useDispatch();
  const isLegacyProject = selectedProject?.[0]?.projectCode === "legacy";
  return props.trigger ? (
    <div className="popup-shade">
      <div className="popup-card card user-options-modal mb-3">
        <div className="card-header user-options-modal__header">
          User Options
          <div className="close-button-space">
            <button
              className="close-button"
              onClick={() => props.setTrigger(false)}
              aria-label="Close user options"
            >
              <img src={closeCoss} alt="" />
            </button>
          </div>
        </div>
        <div className="card-body user-options-modal__body">
          <div className="personal-hub-button-space">
            <a
              className="user-options-modal__link"
              href={PERSONALHUB_PAGE}
              target="_blank"
              rel="noopener noreferrer"
            >
              <button
                className="personal-hub-button user-options-modal__action-btn"
                onClick={() => {
                  props.setTrigger(false);
                  isLegacyProject
                    ? dispatch(
                        updateNavigationState({
                          value: "Legacy Browser",
                          stateName: SELECTED_ICON,
                        }),
                      )
                    : dispatch(
                        updateNavigationState({
                          value: "File Browser",
                          stateName: SELECTED_ICON,
                        }),
                      );
                }}
              >
                PERSONAL HUB
              </button>
            </a>
            {/* <a className="nav-link" href={PERSONALHUB_PAGE}>
              <button className="personal-hub-button">PERSONAL HUB</button>
            </a> */}
          </div>
          <div className="profile-settings-button-space">
            <a
              className="user-options-modal__link"
              href="https://profile.autodesk.com/"
            >
              <button className="profile-settings-button user-options-modal__action-btn">
                PROFILE SETTINGS
              </button>
            </a>
          </div>
          <div className="sign-out-button-space">
            <button
              className="sign-out-button user-options-modal__action-btn"
              onClick={() => props.logOut()}
            >
              SIGN OUT
            </button>
          </div>
        </div>
      </div>
      {/* <div className="popup-card">
        <div className="close-button-space">
          <button
            className="close-button"
            onClick={() => props.setTrigger(false)}
          >
            <img src={closeCoss} alt="" />
          </button>
        </div>
        <div className="title-space">
          <h2>PROFILE OPTIONS</h2>
        </div>
        <div className="profile-settings-button-space">
          <a href="https://profile.autodesk.com/">
            <button className="profile-settings-button">
              PROFILE SETTINGS
            </button>
          </a>
        </div>
        <div className="sign-out-button-space">
          <button className="sign-out-button" onClick={() => props.logOut()}>
            SIGN OUT
          </button>
        </div>
      </div> */}
    </div>
  ) : (
    ""
  );
}

export default UserProfilePopUp;
